module.exports = __webpack_public_path__ + "img/dl.0fb3a1d0.png";